import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import LoanVAService from "services/loanMgt/loan/loanVA/loanVAService";

export const initialState = {
  loading: false,
  loanVAList: [],
  error: null,
};

export const getLoanVAList = createAsyncThunk(
  "loanVA/getLoanVAList",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await LoanVAService.getLoanVAList(data);

      if (Array.isArray(response?.data)) return response.data;
      if (Array.isArray(response?.data?.data)) return response.data.data;
      if (Array.isArray(response?.data?.result)) return response.data.result;

      return [];
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Failed to fetch Loan VA data"
      );
    }
  }
);

export const addLoanVA = createAsyncThunk(
  "loanVA/addLoanVA",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await LoanVAService.addLoanVA(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Failed to save Loan VA"
      );
    }
  }
);

const loanVASlice = createSlice({
  name: "loanVA",
  initialState,
  reducers: {
    clearLoanVAList: (state) => {
      state.loanVAList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoanVAList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLoanVAList.fulfilled, (state, action) => {
        state.loading = false;
        state.loanVAList = action.payload || [];
      })
      .addCase(getLoanVAList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addLoanVA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addLoanVA.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addLoanVA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLoanVAList } = loanVASlice.actions;

export default loanVASlice.reducer;
